import { Duration } from "luxon";

export const defaultTimeAxisDuration = Duration.fromDurationLike({ hour: 2 });
